<template>
    <div :class="['page cats',{ off: !pageOn }]">
        <VHeader type="back" @back="pageOn = false" />
        <div class="page-content" :style="{ backgroundColor: backgroundColor, color: fontColor }">
            <div>
                <img :src="catWords" style="width: 100%;margin-bottom:-20px" />
                <p class="btn" :style="{ backgroundColor: btnColor, color: btnFontColor, marginTop: '20px' }" v-for="cat in cats" @click="setCat(cat)">{{ cat }}</p>
            </div>
        </div> 
    </div>
</template>

<script>

import VHeader from '@/components/VHeader.vue'
import { pageOn } from '@/utils/pageOn.js'
import WebSoc from '@/utils/WebSoc.js'
import { mapActions, mapMutations } from 'vuex';

export default {
    name: 'cats',
    mixins: [ pageOn ],
    computed: {
        client_id () { return this.$store.state.client_id },
        backgroundColor () { return this.$store.state.backgroundColor },
        fontColor () { return this.$store.state.fontColor },
        btnColor () { return this.$store.state.btnColor },
        btnFontColor () { return this.$store.state.btnFontColor },
        catWords () { return this.$store.state.catWords },
        cats () { return this.$store.state.cats },
        ads () { return this.$store.state.ads },
        comps () { return this.$store.state.comps }
    },
    components: {
        VHeader
    },
    methods: {
        setCat ( cat ) {
            this.setValue({ k: 'selectedCat', v: cat });
            if ( this.ads.length > 0 ) { this.pushPage('survey') }
            if ( this.comps.length > 0 ) { this.pushPage('comps') }
        },
        ...mapMutations([
            'setValue',
            'pushPage'
        ])
    }
}

</script>

<style lang="scss">

</style>